import React, {Component} from 'react';
import {DayPilot, DayPilotCalendar, DayPilotNavigator} from "@daypilot/daypilot-lite-react";
import {ResourceGroups} from "./ResourceGroups";
import "./Calendar.css"
/*
import { DataManager,  UrlAdaptor } from '@syncfusion/ej2-data';

const dataManager = new DataManager({
    url: 'http://localhost:8080/api/scheduleevents/getData',
    crudUrl: 'http://localhost:8080/api/scheduleevents/crudActions',
    adaptor: new UrlAdaptor(),
    crossDomain: true
});

*/

class Calendar extends Component {
	
	constructor(props) {
		super(props);

		this.calendarRef = React.createRef();
		this.datePickerRef = React.createRef();

		this.state = {
			viewType: "Resources",
			timeRangeSelectedHandling: "Enabled",
			eventDeleteHandling: "Disabled",
			eventMoveHandling: "Disabled",
			eventsResizeHandling: "Disabled",
			businessBeginsHour: 6,
			businessEndsHour: 22,
			group: "Strathaird",
		};
	}

	get calendar() {
		return this.calendarRef.current.control;
	}

	get datePicker() {
		return this.datePickerRef.current.control;
	}
	
	loadCalendarData() {
		const columns =[
			{name: "Teaching Room 1", id: "oldham-teaching_room_1"},
			{name: "Teaching Room 2", id: "oldham-teaching_room_2"},
                        {name: "Teaching Room 3", id: "oldham-teaching_room_3"},
			{name: "Barbara Dyer 1", id: "lib-barbara_dyer_1"},
                        {name: "Barbara Dyer 2", id: "lib-barbara_dyer_2"},
                        {name: "Brooks Room", id: "library-brooks_room"},
                        {name: "Careers & Enterprise Hub", id: "library-careers_enterprise_hub"},
                        {name: "Syndicate 1", id: "library-syndicate_1"},
                        {name: "Syndicate 2", id: "library-syndicate_2"},
                        {name: "Video Conferencing Booth", id: "library-videoconferencing_1"},
			{name: "Room 11", id: "college-room_11"},
                        {name: "Room 12", id: "college-room_12"},
                        {name: "Room 14", id: "college-room_14"},
                        {name: "Room 5", id: "college-room_5"},
			{name: "Teaching Room 5", id: "straithaird-teaching_room_5"},
			{name: "Tutor Room 12", id: "strathaird-room_12"},
			{name: "Room 1 (Single Hot Desk)", id: "strathaird-room_1"},
			{name: "Music Pavilion", id: "pavilion-music_room"},

		];
	


		const events = [
				{
				id:1,
				text: "busy",
				start: "2023-11-07T15:00:00",
				end: "2023-11-07T17:00:00",
				barColor: "#fcb711",
				resource: "TR1"
			},
			{
                                id: 2,
                                text: "Busy",
                                start: "2023-11-07T18:00:00",
                                end: "2023-11-07T20:00:00",
                                barColor: "#fcb711",
                                resouce: "BD1"
                        },
                        {       id:3,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "TR2"
                        },
                        {       id:4,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "WFR"
                        },
                        {       id:5,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "BR"
                        },
                        {       id:6,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "SY1"
                        },
                        {       id:7,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "CEH"
                        },
		];

		this.calendar.events.load("https://bookings-availability.lucy.cam.ac.uk:3001/getEvents");

		this.calendar.update({columns, events});
	}
	

	componentDidMount() {
		this.datePicker.select();
		this.loadCalendarData();
	}



	loadGroups() { 
		const data = [
			{ name: "select..", id: "blank", resources: [
				{name: "Teaching Room 1", id: "oldham-teaching_room_1"},
                                {name: "Teaching Room 2", id: "oldham-teaching_room_2"},
                                {name: "Teaching Room 3", id: "oldham-teaching_room_3"},
                                {name: "Paul Paget Room", id: "oldham-paul_paget_room"},
				{name: "Barbara Dyer 1", id: "lib-barbara_dyer_1"},
                                {name: "Barbara Dyer 2", id: "lib-barbara_dyer_2"},
                                {name: "Brooks Room", id: "library-brooks_room"},
                                {name: "Careers & Enterprise Hub", id: "library-careers_enterprise_hub"},
                                {name: "Syndicate 1", id: "library-syndicate_1"},
                                {name: "Syndicate 2", id: "library-syndicate_2"},
                                {name: "Video Conferencing Booth", id: "library-videoconferencing_1"},
				{name: "Room 5", id: "college-room_5"},
                                {name: "Room 11", id: "college-room_11"},
                                {name: "Room 12", id: "college-room_12"},
                                {name: "Room 14", id: "college-room_14"},
				{name: "Wolfson Room", id: "strathaird-wolfson_room"},
                                {name: "Wood Legh 1", id: "strathaird-wood_legh_1"},
                                {name: "Wood Legh 2", id: "strathaird-wood_legh_2"},
				{name: "Teaching Room 5", id: "strathaird-teaching_room_5"},
				{name: "Tutor Room 12", id: "strathaird-room_12"},
                                {name: "Room 1 (Single Hot Desk)", id: "strathaird-room_1"},
				{name: "Music Pavilion", id: "pavilion-music_room"},
			]
			},
			{ name: "Oldham Hall", id: "Oldham Hall", resources: [
				{name: "Teaching Room 1", id: "oldham-teaching_room_1"},
				{name: "Teaching Room 2", id: "oldham-teaching_room_2"},
				{name: "Teaching Room 3", id: "oldham-teaching_room_3"},
				{name: "Paul Paget Room", id: "oldham-paul_paget_room"},
			]
			},
			{ name: "Library", id: "Library", resources: [
				{name: "Barbara Dyer 1", id: "lib-barbara_dyer_1"},
				{name: "Barbara Dyer 2", id: "lib-barbara_dyer_2"},
				{name: "Brooks Room", id: "library-brooks_room"},
				{name: "Careers & Enterprise Hub", id: "library-careers_enterprise_hub"},
				{name: "Syndicate 1", id: "library-syndicate_1"},
				{name: "Syndicate 2", id: "library-syndicate_2"},
				{name: "Video Conferencing Booth", id: "library-videoconferencing_1"},
			]
			},
			{ name: "College House", id: "College House", resources: [
				{name: "Room 5", id: "college-room_5"},
				{name: "Room 11", id: "college-room_11"},
				{name: "Room 12", id: "college-room_12"},
				{name: "Room 14", id: "college-room_14"},
			]
			},
			{ name: "Strathaird", id: "Strathaird", resources: [
				{name: "Wolfson Room", id: "strathaird-wolfson_room"},
				{name: "Wood Legh 1", id: "strathaird-wood_legh_1"},
				{name: "Wood Legh 2", id: "strathaird-wood_legh_2"},
				{name: "Teaching Room 5", id: "strathaird-teaching_room_5"},
				{name: "Tutor Room 12", id: "strathaird-room_12"},
                        	{name: "Room 1 (Single Hot Desk)", id: "strathaird-room_1"},
			]
			},

		];
		return data;
	}

	groupChanged(group){

		const columns = group.resources;

		const events = [
			{
				id: 2,
				text: "Busy",
				start: "2023-11-07T18:00:00",
				end: "2023-11-07T20:00:00",
				barColor: "#fcb711",
				resouce: "BD1"
			},
			{	id:3,
				text: "Busy",
				start: "2023-11-07T10:00:00",
				end: "2023-11-07T11:00:00",
				barcolor: "#fcb711",
				resource: "TR2"
			},
			{       id:4,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "WFR"
                        },
			{       id:5,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "BR"
                        },
			{       id:6,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "SY1"
                        },
			{       id:7,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "CEH"
                        },
			{       id:8,
                                text: "Busy",
                                start: "2023-11-07T10:00:00",
                                end: "2023-11-07T11:00:00",
                                barcolor: "#fcb711",
                                resource: "RM14"
                        },


		];
		this.calendar.events.load("https://bookings-availability.lucy.cam.ac.uk:3001/getEvents");

		this.calendar.update({columns, events});
	}

	next() {
		const current = this.datePicker.selectionDay;
		const updated = current.addDays(1);
		this.datePicker.select(updated);
	}

	previous() {
		const current = this.datePicker.selectionDay;
		const updated = current.addDays(-1);
		this.datePicker.select(updated);
	}


	render () {

		return (
			<div className={"wrap"}>
				<div className={"left"}>
					<DayPilotNavigator
						selectMode={"Day"}
						showMonths={3}
						skipMonths={3}
						onTimeRangeSelected={ args => {
							this.calendar.update({
								startDate: args.day
							});
						}}
			ref={this.datePickerRef}

			/>
			</div>
			<div className={"calendar"}>
			<div className={"toolbar"}>
			<ResourceGroups onChange={args => this.groupChanged(args.selected)} items={this.loadGroups()}></ResourceGroups>
			<span>Day:</span>
			<button onClick={ev => this.previous()}>Previous</button> 
			<button onClick={ev => this.next()}>Next</button> 
			<button> <a href="https://t.ly/LCC-Bookings-30m_1h" target="_blank">Book .5 & 1hr</a></button> 
			<button> <a href="https://t.ly/LCC-Bookings-2h_3h" target = "_blank">Book 2 & 3hr</a></button> 
			<button> <a href="https://t.ly/LCC-Bookings-4h_5h" target = "_blank">Book 4 & 5hr</a></button>
			</div>
			<DayPilotCalendar
				{...this.state}
				ref={this.calendarRef}
			/>
			
			<div>
			</div>
			</div>
			</div>
		);
	}
}


/*
function App() {

	const [events] = React.useState(false);

function getData(){
	//fetch('http://localhost:8080/api/scheduleevents/getData')
	fetch('http://localhost:8080/getData')
	.then(response => {
		return response.text();
	});

}


React.useEffect(() => {
	getData();
}, []);



return (
	<div>
	{events ? events : 'no events found'}
	</div>
);


}

*/



export default Calendar;
